'use client';

import React from 'react';
import { NeighborhoodMapCore } from './NeighborhoodMapCore';
import { ExtendedNeighborhood } from './NeighborhoodItem';

export interface NeighborhoodMapProps {
  selectedNeighborhoodIds: string[];
  onNeighborhoodClick: (neighborhoodId: string) => void;
  neighborhoods: ExtendedNeighborhood[];
}

export function NeighborhoodMap(props: NeighborhoodMapProps) {
  return (
    <NeighborhoodMapCore
      {...props}
      height="340px"
      width="100%"
      minHeight="340px"
      minWidth="400px"
    />
  );
}
